'use client';
import {useEffect} from 'react';

import {usePathname} from 'next/navigation';

export const useDomHandler = () => {
  const pathname = usePathname();

  useEffect(() => {
    const $ = require('jquery');
    let isDragging = false;
    let startX: number, scrollLeft: number;

    const r = document.querySelector(':root') as any;

    const numIncrease = (
      selector: any,
      targetNumber: number,
      duration = 800
    ) => {
      const startNumber = 0;
      const startTime = performance.now();
      const increment = targetNumber / duration;
      if ($(selector).hasClass('done')) {
        return;
      }
      $(selector).addClass('done');
      function update() {
        const currentTime = performance.now();
        const elapsed = currentTime - startTime;
        const currentNumber = Math.min(
          startNumber + increment * elapsed,
          targetNumber
        );
        $(selector).text(Math.floor(currentNumber));

        if (currentNumber < targetNumber) {
          requestAnimationFrame(update);
        }
      }
      requestAnimationFrame(update);
    };

    const showElement = (selector: any, display: boolean | null = null) => {
      const element = $(selector);

      if (display === null) {
        display = element.hasClass('hidden');
      }

      if (display) {
        element.removeClass('hidden');
      } else {
        element.addClass('hidden');
      }
    };

    const focus = (selector: any) => {
      setTimeout(() => {
        $(selector).focus();
      }, 100);
    };

    const toggleClass = (selector: any, className: string) => {
      $(selector).toggleClass(className);
    };

    const search = (selector = "[name='keyword']") => {
      const keywordVal = $(selector).val();
      if (typeof keywordVal === 'string' && keywordVal.trim() !== '') {
        window.location.href = '/search/?q=' + keywordVal;
      }
    };

    const transparantMenu = (isTransparant: any) => {
      if (isTransparant === 'true') {
        $('.icon-white').show();
        $('.icon-dark').hide();
        r?.style.setProperty('--color-menu', 'white');
        r?.style.setProperty('--bg-menu', 'transparant');
      } else {
        $('.icon-white').hide();
        $('.icon-dark').show();
        r?.style.setProperty('--color-menu', '#000');
        r?.style.setProperty('--bg-menu', '#F7F8FA');
      }
    };

    const gradientTo = (
      selector: any,
      targetNumber: number,
      duration = 800
    ) => {
      const startNumber = 0;
      const startTime = performance.now();
      const increment = targetNumber / duration;
      if ($(selector).hasClass('done')) {
        return;
      }
      $(selector).addClass('done');
      function update() {
        const currentTime = performance.now();
        const elapsed = currentTime - startTime;
        const currentNumber = Math.min(
          startNumber + increment * elapsed,
          targetNumber
        );
        $(selector).css({
          background: `conic-gradient(#004c98 0% ${Math.floor(currentNumber)}%, #ccc 50% 100%)`
        });

        if (currentNumber < targetNumber) {
          requestAnimationFrame(update);
        }
      }
      requestAnimationFrame(update);
    };

    const scroll = (scrollLeftVal: number, selector: any) => {
      $(selector).parent().scrollLeft(scrollLeftVal);
    };

    const syncHeight = (element: any, selector: any) => {
      const height = $(selector).height();
      element.css({height: height + 'px'});
    };

    const onHandlers: Record<string, Function> = {
      showElement,
      toggleClass,
      numIncrease,
      gradientTo,
      search,
      focus,
      scroll,
      syncHeight,
      transparantMenu
    };

    const formPageData = () => {
      setTimeout(() => {
        $('.scroll-left').scrollLeft(300);
      });

      $('.on').each((i: any, item: any) => {
        const element = $(item);
        element.off(); // Remove existing handlers to avoid duplicates on re-render
        const classNames = item.className.split(' ');
        classNames.forEach((className: string) => {
          if (className.startsWith('on-')) {
            const trigger = className.split('-');
            const variables = [...(className.match(/\[(.*?)\]/g) ?? [])].map(
              (str) => str.replace('[', '').replace(']', '')
            );
            switch (trigger[1]) {
              case 'resize':
                window.addEventListener('resize', () => {
                  onHandlers[trigger[2]]?.(element, ...variables);
                });
                break;
              case 'scroll':
                if (trigger[1] === 'scroll') {
                  const scrollbar = element;
                  const container = scrollbar.parent();
                  const content = $(variables[0]); // target

                  scrollbar.css({position: 'absolute', left: '0px'});

                  scrollbar.on('mousedown', (e: MouseEvent) => {
                    isDragging = true;
                    startX = e.pageX - scrollbar.offset()!.left;
                    e.preventDefault(); // prevent text selection
                  });

                  document.addEventListener('mousemove', (e: MouseEvent) => {
                    if (!isDragging) return;
                    e.preventDefault();

                    const containerWidth = container.width() || 0;
                    const scrollbarWidth = scrollbar.width() || 0;
                    const maxLeft = containerWidth - scrollbarWidth;

                    const x = e.pageX - container.offset()!.left - startX;
                    scrollLeft = Math.max(0, Math.min(x, maxLeft));

                    scrollbar.css({left: scrollLeft + 'px'});

                    const contentWidth = content[0]?.scrollWidth || 0;
                    const maxScrollLeft = contentWidth - containerWidth;

                    const scrollRatio = scrollLeft / maxLeft;
                    const contentScrollLeft = scrollRatio * maxScrollLeft;

                    onHandlers[trigger[2]]?.(contentScrollLeft, ...variables);
                  });

                  container.on('click', (e: MouseEvent) => {
                    const containerWidth = container.width() || 0;
                    const scrollbarWidth = scrollbar.width() || 0;
                    startX = e.pageX - e.clientX + scrollbarWidth / 2;

                    const maxLeft = containerWidth - scrollbarWidth;

                    const x = e.pageX - container.offset()!.left - startX;
                    scrollLeft = Math.max(0, Math.min(x, maxLeft));

                    scrollbar.css({left: scrollLeft + 'px'});

                    const contentWidth = content[0]?.scrollWidth || 0;
                    const maxScrollLeft = contentWidth - containerWidth;

                    const scrollRatio = scrollLeft / maxLeft;
                    const contentScrollLeft = scrollRatio * maxScrollLeft;

                    onHandlers[trigger[2]]?.(contentScrollLeft, ...variables);
                  });
                }
                break;
              case 'hover':
                element.on('mouseenter', () => {
                  onHandlers[trigger[2]]?.(...variables);
                });
                break;
              case 'click':
                element.on(trigger[1], () => {
                  onHandlers[trigger[2]]?.(...variables);
                });
                break;
              case 'enter':
                element.on('keypress', (e: KeyboardEvent) => {
                  if (e.keyCode === 13) {
                    onHandlers[trigger[2]]?.(...variables);
                  }
                });
                break;
            }
          }
        });
      });
    };

    formPageData();

    const init = () => {
      if (($(window).scrollTop() || 0) > 0) {
        $('.icon-white').hide();
        $('.icon-dark').show();
        r?.style.setProperty('--color-menu', '#000');
        r?.style.setProperty('--bg-menu', '#F7F8FA');
      } else {
        $('.icon-white').show();
        $('.icon-dark').hide();
        r?.style.setProperty('--color-menu', 'white');
        r?.style.setProperty('--bg-menu', 'transparant');
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if ($(entry.target)[0]) {
              const target = $(entry.target)[0];
              const classNames = target.className.split(' ');
              classNames.forEach((className: string) => {
                if (className.startsWith('observe-in-')) {
                  const trigger = className.split('-');
                  const variables = [
                    ...(className.match(/\[(.*?)\]/g) ?? [])
                  ].map((str) => str.replace('[', '').replace(']', ''));
                  onHandlers[trigger[2]]?.(target, ...variables);
                }
              });
            }
          }
        });
      });

      $('.observe').each(function (this: Element) {
        observer.observe(this);
      });
    };

    init();

    const handleScroll = () => {
      init();
    };

    $(window).on('scroll', handleScroll);

    const handleMouseUp = () => {
      isDragging = false;
    };
    document.addEventListener('mouseup', handleMouseUp);

    $('.do').each((i: any, item: any) => {
      const element = $(item);
      const classNames = item.className.split(' ');
      classNames.forEach((className: string) => {
        if (className.startsWith('do-')) {
          const trigger = className.split('-');
          const variables = [...(className.match(/\[(.*?)\]/g) ?? [])].map(
            (str) => str.replace('[', '').replace(']', '')
          );
          switch (trigger[1]) {
            case 'syncHeight':
              onHandlers[trigger[1]]?.(element, ...variables);
              break;
          }
        }
      });
    });

    return () => {
      $(window).off('scroll', handleScroll);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [pathname]);
};
